import styled from 'styled-components'

export default styled.div`
  max-width: 950px;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./components/atoms/sizer.js